var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5766 1.77268C11.5766 1.77268 11.2083 2.87771 10.5242 3.56178C11.3661 8.82385 5.57787 12.6652 1.05249 9.66578C2.21015 9.7184 3.3678 9.35006 4.20973 8.61337C1.5787 7.82406 0.26318 4.71944 1.5787 2.29888C2.73635 3.66702 4.52546 4.45633 6.31456 4.40371C5.84097 2.19364 8.41939 0.930746 9.99801 2.40413C10.5768 2.40413 11.5766 1.77268 11.5766 1.77268Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.629,
    height: 12.629,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b0de8a41bf106226e228c94eda0957aa.svg";
export { ForwardRef as ReactComponent };